import { AiOutlineEdit } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import NoDefaultRuleExistCreateNewOne from './NoDataContainer';
import type { OwnerType } from '../../../../common/constants';
import RuleSummary from '../../../receipts/components/RuleSummary';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import {useGetRuleByOwnerQuery} from "../../../receipts/receipt.api-slice";

interface IProps {
  ownerEntityType: OwnerType;
  ownerEntityId: string;
}

const RuleDataContainer: React.FC<IProps> = ({ ownerEntityType, ownerEntityId }) => {
  const { data: rule } = useGetRuleByOwnerQuery(ownerEntityId !== '' ? { ownerEntityType, ownerEntityId } : skipToken);

  return (
    <div className="min-h-[200px]">
      <div className="h-full flex flex-col">
        <div className="w-full border-b-2 pb-1 flex justify-between items-center">
          <span className="font-xl font-bold text-xl">Default Rule</span>
          {rule?.id != null && (
            <Link to={`/admin/rules/${ownerEntityType}/${ownerEntityId}`}>
              <div className="flex py-2 text-gray-50 px-2 bg-[#1D8A43] text-center rounded-lg space-between  justify-center items-center">
                <AiOutlineEdit size={20} />
                <button className="text-sm px-2">Edit</button>
              </div>
            </Link>
          )}
        </div>
        {rule == null && (
          <NoDefaultRuleExistCreateNewOne ownerEntityType={ownerEntityType} ownerEntityId={ownerEntityId} />
        )}
        {rule != null && <RuleSummary rule={rule} />}
      </div>
    </div>
  );
};

export default RuleDataContainer;
